import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, _mergeProps(_ctx.$attrs, {
    items: _ctx.items,
    "item-title": _ctx.itemText || 'text',
    "item-value": _ctx.itemValue || _ctx.itemText
  }), {
    item: _withCtx(({ item, props }) => [
      _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), _createSlots({ _: 2 }, [
        (_ctx.items.some(i => i.icon))
          ? {
              name: "prepend",
              fn: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.icon), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              key: "0"
            }
          : undefined
      ]), 1040)
    ]),
    selection: _withCtx(({item}) => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        align: "center"
      }, {
        default: _withCtx(() => [
          (item.icon)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "auto",
                class: "pr-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.icon), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.itemText ? item[_ctx.itemText] : item.text), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }, 16, ["items", "item-title", "item-value"]))
}